/*
 * DE/RE Tracker Install — custom product template behavior.
 *
 * Loaded (deferred) only from snippets/variant-matrix.liquid on the "dere"
 * template. The template renders a single instance, so hooks are plain
 * classes/ids scoped within `.dere-wrap` (no per-section namespacing needed).
 *
 * The DE/RE dropdowns are a friendly UI for the hidden native "Truck Type"
 * <select> Dawn renders inside <variant-selects>. On change we copy the
 * "<DE> → <RE>" combo into that native select and fire a bubbling 'change';
 * Dawn then resolves the variant (truck + antennas + brackets) and handles
 * price, availability, the cart variant id, and the URL natively.
 */
(function () {
  var wrap = document.querySelector('.dere-wrap');
  if (!wrap) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Carousel ---- */
  var carousel = wrap.querySelector('.dere-carousel');
  var track = wrap.querySelector('.dere-carousel__track');
  var prevBtn = wrap.querySelector('.dere-carousel__btn--prev');
  var nextBtn = wrap.querySelector('.dere-carousel__btn--next');
  var dots = wrap.querySelectorAll('.dere-carousel__dot');
  var slides = wrap.querySelectorAll('.dere-carousel__slide');
  var total = slides.length || dots.length || 1;
  var current = 0;

  function goTo(index) {
    current = ((index % total) + total) % total;
    if (track) track.style.transform = 'translateX(-' + (current * 100) + '%)';
    dots.forEach(function (d, i) { d.classList.toggle('dere-carousel__dot--active', i === current); });
  }

  if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); goTo(current - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); goTo(current + 1); });
  dots.forEach(function (dot, i) { dot.addEventListener('click', function (e) { e.stopPropagation(); goTo(i); }); });

  /* ---- Truck combination -> hidden native Truck Type select ---- */
  var deSelect = wrap.querySelector('.dere-de-select');
  var reSelect = wrap.querySelector('.dere-re-select');
  var comboLabel = wrap.querySelector('.dere-combo-label');
  var variantImg = wrap.querySelector('#dere-variant-img');

  function getCombo() { return deSelect.value + ' → ' + reSelect.value; }

  function nativeTruckSelect() {
    return document.querySelector('variant-selects select[name="options[Truck Type]"]');
  }

  function driveNativeTruck() {
    var combo = getCombo();
    if (comboLabel) comboLabel.textContent = combo;
    var sel = nativeTruckSelect();
    if (!sel) return;
    if (sel.value === combo) return;
    var hasOption = Array.prototype.some.call(sel.options, function (o) { return o.value === combo; });
    if (!hasOption) return; // combo is not a real Truck Type value
    sel.value = combo;
    sel.dispatchEvent(new Event('change', { bubbles: true }));
  }

  if (deSelect) deSelect.addEventListener('change', driveNativeTruck);
  if (reSelect) reSelect.addEventListener('change', driveNativeTruck);

  /* ---- Keep the hero image in sync with the variant Dawn resolves ---- */
  function updateHeroImage(variant) {
    if (!variantImg || !variant) return;
    var src =
      (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) ||
      (variant.featured_image && variant.featured_image.src) || '';
    if (!src) return;
    if (reduceMotion) {
      variantImg.src = src;
      variantImg.alt = variant.option1 || '';
    } else {
      variantImg.style.opacity = '0';
      setTimeout(function () {
        variantImg.src = src;
        variantImg.alt = variant.option1 || '';
        variantImg.style.opacity = '1';
      }, 150);
    }
    goTo(0);
  }

  function onVariantChange(event) {
    var variant = event && event.data && event.data.variant;
    if (comboLabel && variant && variant.option1) comboLabel.textContent = variant.option1;
    updateHeroImage(variant);
  }

  function registerVariantChange() {
    var evt = (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) ? PUB_SUB_EVENTS.variantChange : 'variant-change';
    if (typeof subscribe === 'function') subscribe(evt, onVariantChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', registerVariantChange);
  } else {
    registerVariantChange();
  }

  /* ---- Lightbox (click a slide to zoom) with basic a11y ---- */
  if (carousel) {
    var lastFocused = null;
    var lightbox = document.createElement('div');
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Image viewer');
    lightbox.style.cssText = 'display:none;position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.92);z-index:9999;cursor:zoom-out;align-items:center;justify-content:center;';

    var lightboxImg = document.createElement('img');
    lightboxImg.alt = '';
    lightboxImg.style.cssText = 'max-width:92vw;max-height:92vh;object-fit:contain;border-radius:6px;';

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', 'Close image viewer');
    closeBtn.textContent = '✕';
    closeBtn.style.cssText = 'position:absolute;top:1.5rem;right:2rem;background:none;border:none;color:#fff;font-size:2.4rem;cursor:pointer;line-height:1;';

    lightbox.appendChild(lightboxImg);
    lightbox.appendChild(closeBtn);
    document.body.appendChild(lightbox);

    function openLightbox() {
      var activeImg = slides[current] && slides[current].querySelector('img');
      if (!activeImg) return;
      lastFocused = document.activeElement;
      lightboxImg.src = activeImg.src;
      lightboxImg.alt = activeImg.alt || '';
      lightbox.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    }

    function closeLightbox() {
      lightbox.style.display = 'none';
      document.body.style.overflow = '';
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    carousel.addEventListener('click', openLightbox);
    closeBtn.addEventListener('click', function (e) { e.stopPropagation(); closeLightbox(); });
    lightbox.addEventListener('click', closeLightbox);
    lightbox.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeLightbox(); }
      // Single focusable element: keep focus trapped on the close button.
      if (e.key === 'Tab') { e.preventDefault(); closeBtn.focus(); }
    });
  }

})();
